import CorePeopleSearch from './CorePeopleSearch';

export { type CorePeopleSearchProps } from './CorePeopleSearch';
export default CorePeopleSearch;
